'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _booking = require('../../redux/modules/booking');

var _modal = require('../../redux/modules/modal');

var _action = require('../../redux/modules/action');

var _select = require('../../redux/modules/select');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    attr: state.action.attr,
    reasonId: state.modal.reason
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    load: _booking.load, hideReason: _modal.hide, loadActions: _action.load, setAction: _action.setAction, setReasonVal: _modal.setReasonVal, selectList: _select.selectList
  }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.getSelectedVal = function (evt) {
      var value = parseInt(evt.target.value, 10);
      _this.props.setReasonVal(value);
    }, _this.confirm = function (evt) {
      evt.preventDefault();
      var $props = _this.props;
      var attr = $props.attr;
      var method = attr.method;
      var path = attr.path;
      var body = (0, _stringify2.default)({
        failure_reason_id: $props.reasonId
      });
      $props.setAction(method, path, body).then(function () {
        $props.checkOrderStatus();
        $props.selectList('');
      });
      $props.hideReason();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Modal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var attr = this.props.attr;

      var styles = require('./Modal.scss');
      var reason = attr ? attr.failure_reasons.map(function (val, key) {
        return _react2.default.createElement(
          'div',
          { className: 'radio', key: key },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement('input', { type: 'radio', name: 'reason', value: val.id, onChange: _this2.getSelectedVal }),
            val.reason
          )
        );
      }) : null;

      return _react2.default.createElement(
        'div',
        { className: styles.modalWrapper },
        _react2.default.createElement('div', { className: styles.overlay, onClick: this.props.hideReason }),
        _react2.default.createElement(
          'div',
          { className: styles.modal },
          _react2.default.createElement(
            'form',
            { onSubmit: this.confirm },
            _react2.default.createElement(
              'h3',
              { className: styles.title },
              attr ? attr.action : 'Cancel',
              ' Reason'
            ),
            reason,
            _react2.default.createElement(
              'button',
              { className: styles.confirm },
              'confirm'
            )
          )
        )
      );
    }
  }]);
  return Modal;
}(_react.Component), _class2.propTypes = {
  attr: _propTypes2.default.object,
  reasonId: _propTypes2.default.number,
  hideReason: _propTypes2.default.func,
  load: _propTypes2.default.func,
  loadActions: _propTypes2.default.func,
  setAction: _propTypes2.default.func,
  setReasonVal: _propTypes2.default.func,
  checkOrderStatus: _propTypes2.default.func,
  selectList: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.js
// module id = 862
// module chunks = 0